/**
 * Shared loading/error banner for a query-backed enum field's options (currently only
 * 'format', via FormatEnumOptions) — used by both `ConstantEditorDialog`
 * (mapping-transforms-constant-dialog.tsx) and `ValueMapEditorDialog`
 * (mapping-transforms-value-map-dialog.tsx) so the banner markup lives in one place instead
 * of being copy-pasted (and drifting) per dialog.
 */
export interface EnumOptionsStatusBannerProps {
  variant: 'loading' | 'error';
  message: string;
  testId: string;
}

export function EnumOptionsStatusBanner({
  variant,
  message,
  testId,
}: EnumOptionsStatusBannerProps) {
  if (variant === 'error') {
    return (
      <div
        className="rounded-md border border-red-300 bg-red-50 px-3 py-2 text-xs text-red-700"
        data-testid={testId}
      >
        {message}
      </div>
    );
  }
  return (
    <div className="py-2 text-xs text-muted-foreground" data-testid={testId}>
      {message}
    </div>
  );
}
